import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Form,
  Nav,
  ProgressBar,
  Spinner
} from "react-bootstrap";
import "./Creategroup.css";
import { IoIosArrowForward } from "react-icons/io";
import ChartCheckbox from "../../Dashboard/Tools/ChartCheckbox";
import toast, { Toaster } from 'react-hot-toast';
import axios from "axios";
import Select from 'react-select'
import { useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';

function CreateGroup() {

  const navigate = useNavigate();

  const [activeStep, setActiveStep] = useState(1);
  const [disableStepCls, setDisableStepCls] = useState(false);
  const [loading, setLoading] = useState(false);
  const [CommissionGrp, setCommissionGrp] = useState(
    {
      name: "",
      rs_structure: {
        used: false,
        calcbasis: "",
        administrator: 0,
        percentage: 0,
        negativecomm: false
      },
      ref_structure: {
        used: false,
        calcbasis: "",
        levels: [],
        negativecomm: false
      },
      cpa_structure: {
        used: false,
        amount: 0
      }
    }
  )
  const [rsValidation, setRsValidation] = useState("")
  const [structureType, setStructureType] = useState({
    type: "",
    nextStep: 1
  })
  const [cpaParamLevel, setCpaParamLevel] = useState([])
  const [isChecked, setIsChecked] = useState(false);
  const [registartionsChecked, setRegistrationChecked] = useState(true);
  const [depositChecked, setDepositChecked] = useState(false);
  const [profitChecked, setProfitChecked] = useState(false);
  const [pLoading, setPloading] = useState(false);
  const [levels, setLevels] = useState([{
    percentage: 0,
    registrations: 0,
    profit: 0,
    deposits: 0
  }]);
  const [strcutre, setStructure] = useState(false)
  const [cpaLevel, setCpaevel] = useState([1])
  const [commmissionLevel, setCommissionLevel] = useState([{
    level: 1,
    percentage: 0
  }])
  const [lastTtier, setLastTier] = useState({
    last: true,
    percentage: 0
  })
  const [usedRs, seUsedRes] = useState(false)
  const [usedRef, seUsedRef] = useState(false)
  const [usedcpa, seUsedpa] = useState(false)
  const [GrprsValidation, setGrpValidtaion] = useState({
    name: null,
    type: null,
    st_rs: {
      calcbasis: null,
      commi: null,
      administrator: null,
      last_tier: null,
      tiers: null,
      negativecomm: null
    },
    st_ref: {
      lvl: [{ index: 0 }],
      refCalcbasis: null,
    },
    st_cpa: {
      cpa: null
    }
  })
  const [resetTrigger, setResetTrigger] = useState(false)
  const [tierConditions, setTierConditions] = useState({
    profit: false,
    registrations: true,
    deposits: false
  })
  const [tiersValidations, setTiersValidations] = useState([])
  const [commissionRefValidation, setCommissionrefValidation] = useState([])
  const totalSteps = 5;
  const [affliate, setAffliate] = useState({});
  const StoreUser = useSelector((state) => state.user);
  const [affliatePermission, setAffliatePermission] = useState(false)
  const checkPermission = (user, permission) => {
    var Permissions = user.Permissions;
    if (Permissions && Permissions.length > 0) {
      const index = Permissions.findIndex(per => per === permission)
      if (index != -1) return true;
      else return false;
    }
    return true
  }
  const handleNext = () => {
    var initValue = {
      name: null,
      type: null,
      st_rs: {
        calcbasis: null,
        commi: null,
        administrator: null,
        negativecomm: null
      },
      st_ref: {
        lvl: null,
      },
      st_cpa: {
        cpa: null
      }
    }
    if (structureType.type != "" && CommissionGrp.name != "") {
      if (activeStep == 1 && structureType.type == "REF") {
        setActiveStep(4)
      }
      else if (activeStep == 1 && structureType.type == "CPA") {
        setActiveStep(3)
      }
      else if (activeStep == 1 && structureType.type == "REV") {
        setActiveStep(2)
      }
      else {

        setActiveStep(activeStep + 1);
      }
    }
    else {
      if (structureType.type == "")
        initValue.type = "Type is required"
      setGrpValidtaion({ ...GrprsValidation, type: "type is required " })
    }
    if (CommissionGrp.name == "") {
      initValue.name = "Name is required"
      setGrpValidtaion({ ...GrprsValidation, type: "name is required " })
    }

    setGrpValidtaion(initValue)
    if (activeStep === totalSteps) {
      savedCommissionGroup()
      // setActiveStep(1)
    }
    setTiersValidations([])
  };
  useEffect(() => {
    if (CommissionGrp.name != "")
      setGrpValidtaion({ ...GrprsValidation, name: null })
    if (structureType.type != "")
      setGrpValidtaion({ ...GrprsValidation, type: null })
    if (CommissionGrp.rs_structure.calcbasis != "")
      setGrpValidtaion(prevstat => ({ ...prevstat, st_rs: { ...prevstat.st_rs, calcbasis: null } }))

  }, [CommissionGrp, structureType])

  const handleBack = () => {
    if (activeStep > 1) {
      setActiveStep(activeStep - 1); // Decrement step
    }
  };
  const handleAddLevel = () => {
    setLevels([...levels, {
      percentage: 0,
      registrations: 0,
      profit: 0,
      deposits: 0
    }]);
    if (tiersValidations.length > 0) {
      setTiersValidations([...tiersValidations, {
        index: levels.length - 1
      }])
    }
  };
  const addCpaParamLevel = () => {
    setCpaParamLevel([...cpaParamLevel, {}]);
  }
  const deleteCpaParamLevel = () => {
    if (cpaParamLevel.length > 0) {
      setCpaParamLevel(cpaParamLevel.slice(0, -1)); // Remove the last level
    }
  }
  const addCpaLevel = () => {
    setCpaevel([...cpaLevel, {}]);
  }
  const addCommissionLevel = () => {
    setCommissionLevel([...commmissionLevel, {
      level: commmissionLevel.length + 1,
      percentage: 0
    }])
    if (GrprsValidation.st_ref.lvl) {
      var ItGrprsVal = Object.assign({}, GrprsValidation)
      ItGrprsVal.st_ref.lvl.push({
        index: ItGrprsVal.st_ref.lvl.length - 1
      })
      setGrpValidtaion(ItGrprsVal)
    }
  }
  const handleDeleteCpaLevel = () => {
    if (cpaLevel.length > 1) {
      setCpaevel(cpaLevel.slice(0, -1)); // Remove the last level
    }
  }
  const handleDeleteCommissionLevel = () => {
    if (commmissionLevel.length > 1) {
      setCommissionLevel(commmissionLevel.slice(0, -1)); // Remove the last level
    }
    if (GrprsValidation.st_ref.lvl && GrprsValidation.st_ref.lvl.length > 0) {
      var ItGrprsVal = Object.assign({}, GrprsValidation)
      ItGrprsVal.st_ref.lvl.slice(0, -1)
      setGrpValidtaion(ItGrprsVal)
    }
  }
  // Function to handle deleting a level
  const handleDeleteLevel = () => {
    if (levels.length > 1) {
      setLevels(levels.slice(0, -1));
      CommissionGrp.rs_structure.tiers.slice(0, -1);
    }
    if (tiersValidations.length > 0) {
      setTiersValidations(tiersValidations.slice(0, -1))
    }
  };

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
    if (isChecked) {
      setCommissionGrp(prevstat => {
        const updatedStructure = { ...prevstat.rs_structure };
        delete updatedStructure.tiers;

        return {
          ...prevstat,
          rs_structure: updatedStructure
        };
      });
    }
    if (!isChecked) {
      setLevels([{
        percentage: 0,
        registrations: 0,
        profit: 0,
        deposits: 0
      }])
      setTiersValidations([])
      var GrprsValidationsIterator = Object.assign({}, GrprsValidation)
      GrprsValidationsIterator.st_rs.last_tier = null
      setGrpValidtaion(GrprsValidationsIterator)
    }
  };
  const handleRegistrationchange = () => {
    setRegistrationChecked(!registartionsChecked)
    setTierConditions({ ...tierConditions, registrations: !registartionsChecked })
  }
  const handleDepositChange = () => {
    setDepositChecked(!depositChecked)
    setTierConditions({ ...tierConditions, deposits: !depositChecked })

  }
  const handleProfitChange = () => {
    setProfitChecked(!profitChecked)
    setTierConditions({ ...tierConditions, profit: !profitChecked })

  }
  const handlestructurechange = () => {
    setStructure(!strcutre)
  }
  const createRevenueShareStruct = () => {
    var initValue = Object.assign({}, GrprsValidation)
    var errored = false;
    if (CommissionGrp.rs_structure.calcbasis === "") {
      initValue.st_rs.calcbasis = "Calculation basis field is required"
      errored = true;
    }
    // if (CommissionGrp.rs_structure.administrator === 0) {
    //   initValue.st_rs.administrator = "administrator cannot be valued 0"
    //   errored = true;
    // }
    if (CommissionGrp.rs_structure.percentage === 0) {
      initValue.st_rs.commi = "Commission cannot be valued 0"
      errored = true;
    }
    if (CommissionGrp.rs_structure.tiers && CommissionGrp.rs_structure.tierconditions) {
      if (lastTtier.percentage === 0) {
        initValue.st_rs.last_tier = "Commission % higher than level field cannot be valued 0"
        errored = true;
      }
      if (CommissionGrp.rs_structure.tiers.length > 0) {
        const newTiers = levels.map((level, index) => {
          const errors = {};
          errors.index = index
          if (level.percentage === 0) errors.percentage = 'Commission is required';
          if (level.registrations === 0 && tierConditions.registrations) errors.registrations = 'Registrations are required';
          if (level.profit === 0 && tierConditions.profit) errors.profit = 'Profit is required';
          if (level.deposits === 0 && tierConditions.deposits) errors.deposits = 'Deposits are required';
          if (errors.percentage || errors.registrations || errors.profit || errors.deposits)
            errored = true;
          return Object.keys(errors).length > 0 ? errors : null; // Return errors if any
        });
        setTiersValidations(newTiers);
      }
    }
    if (!depositChecked && !registartionsChecked && !profitChecked) {
      setRsValidation("At least one of parameters for tier is required")
      errored = true;
    }

    setGrpValidtaion(initValue)
    if (errored) return;
    setCommissionGrp(prevstat => ({ ...prevstat, rs_structure: { ...prevstat.rs_structure, used: true } }))
    toast.success("Data Saved Successfully", {
      duration: 3000
    });
    setActiveStep(activeStep + 1);

  }
  const createCPAStruct = () => {
    var cpaValidation = Object.assign({}, GrprsValidation)
    var errored = false;
    if (CommissionGrp.cpa_structure.amount === 0) {
      cpaValidation.st_cpa.cpa = "CPA Amount is required";
      errored = true
    }
    setGrpValidtaion(cpaValidation);
    if (errored) return;
    setCommissionGrp(prevstat => ({ ...prevstat, cpa_structure: { ...prevstat.cpa_structure, used: true } }))
    toast.success("Data Saved Successfully", {
      duration: 3000
    });
    setActiveStep(activeStep + 1);
  }
  const createRefStruct = () => {
    var refValidation = Object.assign({}, GrprsValidation);
    var errored = false;
    if (CommissionGrp.ref_structure.levels.length > 0) {
      const refLevels = CommissionGrp.ref_structure.levels.map((lvl, index) => {
        const errors = {};
        errors.index = index
        if (lvl.percentage === 0) {
          errors.percentage = 'Commission is required';
          errored = true;
        }
        return Object.keys(errors).length > 0 ? errors : null;
      })
      refValidation.st_ref.lvl = refLevels;
    }
    if (CommissionGrp.ref_structure.calcbasis === "") {
      refValidation.st_ref.refCalcbasis = "Calculation Basis is required";
      errored = true;
    }
    setGrpValidtaion(refValidation);

    if (errored) return;
    setCommissionGrp(prevstat => ({ ...prevstat, ref_structure: { ...prevstat.ref_structure, used: true } }))
    toast.success("Data Saved Successfully", {
      duration: 3000
    });
    setActiveStep(activeStep + 1);

  }
  const resetCommssionGrp = () => {
    setCommissionGrp({
      name: "",
      rs_structure: {
        used: false,
        calcbasis: "",
        administrator: 0,
        percentage: 0,
        negativecomm: false
      },
      ref_structure: {
        used: false,
        calcbasis: "",
        levels: [],
        negativecomm: false
      },
      cpa_structure: {
        used: false,
        amount: 0
      }
    })

    setLevels([{
      percentage: 0,
      registrations: 0,
      profit: 0,
      deposits: 0
    }])
    setIsChecked(false)
    setResetTrigger(true)
    setStructureType({
      type: "",
      nextStep: 1
    })
    setActiveStep(1);
  }
  useEffect(() => {

    if (levels.length > 0 && isChecked) {
      const combinedLevels = [...levels, lastTtier];
      setCommissionGrp(prevstat => ({ ...prevstat, rs_structure: { ...prevstat.rs_structure, tiers: combinedLevels } }))
      setCommissionGrp(prevstat => ({ ...prevstat, rs_structure: { ...prevstat.rs_structure, tierconditions: tierConditions } }))

    }
    else {
      setDepositChecked(false)
      setProfitChecked(false)
    }
  }, [levels, lastTtier, isChecked])
  
  const resetlevel = () => {
    if (!registartionsChecked) {
      setLevels(prevLevels =>
        prevLevels.map(lvl => ({
          ...lvl,
          registrations: 0,
        }))
      );
    }
    if (!depositChecked) {
      setLevels(prevLevels =>
        prevLevels.map(lvl => ({
          ...lvl,
          deposits: 0,
        }))
      );
    }
    if (!profitChecked) {
      setLevels(prevLevels =>
        prevLevels.map(lvl => ({
          ...lvl,
          profit: 0,
        }))
      );
    }
  }

  const savedCommissionGroup = async () => {
    setPloading(true);
    const response = await axios.post(window.__CFG.API + "commissions/CreateCommissionGroup", CommissionGrp, {
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("raff-token")
      }
    })
    setPloading(false);
    if (response.data.Error == null) {
      toast.success("Data Saved Successfully", {
        duration: 3000
      });
      setCommissionGrp({
        name: "",
        rs_structure: {
          used: false,
          calcbasis: "",
          administrator: 0,
          percentage: 0,
          negativecomm: false

        },
        ref_structure: {
          used: false,
          calcbasis: "",
          levels: [],
          negativecomm: false
        },
        cpa_structure: {
          used: false,
          amount: 0
        }
      })
      setStructureType({
        type: "",
        nextStep: 1
      })
      navigate("/affiliate/commission-groups");
    }
  }
  useEffect(() => { setAffliatePermission(checkPermission(affliate, "aff_create_commission_group")) }, [affliate])
  useEffect(() => {
    if (StoreUser != undefined) {
      setAffliate(StoreUser.User)
    }
  }, [affliate])
  useEffect(() => {
    resetlevel();
    if (!depositChecked && !registartionsChecked && !profitChecked) {
      setRsValidation("At least one of parameters for tier is required")
    }
    else {
      setRsValidation("")
    }
  }, [depositChecked, registartionsChecked, profitChecked]);

  useEffect(() => {
    if (commmissionLevel.length > 0) {
      setCommissionGrp(prevstat => ({ ...prevstat, ref_structure: { ...prevstat.ref_structure, levels: commmissionLevel } }))
    }
  }, [commmissionLevel])
  useEffect(() => {
    seUsedRes(CommissionGrp.rs_structure.used)
    seUsedRef(CommissionGrp.ref_structure.used)
    seUsedpa(CommissionGrp.cpa_structure.used)


  }, [CommissionGrp])
  const optionsCurrency = [{ label: "USD", value: 1 }]
  const optionsStructureType = [{ label: "REV", value: "REV" }, { label: "CPA", value: "CPA" }, { label: "REF", value: "REF" }]
  const optionsCalculBasis = [{ label: "Profits", value: "profit" }, { label: "Total deposits", value: "totaldeposits" }, { label: "Total bets", value: "totalbets" }]
  const optionsCalculBasisRef = [{ label: "Profits", value: "profit" }]
  const optionsNegativeCom = [{ label: "Yes", value: true }, { label: "No", value: false }]
  const selectedNgatveCom = optionsNegativeCom.find(option => option.value === CommissionGrp.rs_structure.negativecomm)
  const selectedCurrencyValue = optionsCurrency.find(option => option.value === 1)

  return (
    <>
      <Container fluid>
        <Row >
          <Col>
            <Row
              className="mt-4 me-4"
              style={{ display: "flex", alignItems: "center", width: "100%" }}
            >
              <Col lg={12} md={3} sm={4} style={{ flex: 1 }}>
                <span style={{ fontSize: 19 }} className="fw-bold h4">Create Commission Group</span>
              </Col>
              <Col lg={12} md={3} sm={4} style={{ flex: 1, textAlign: "end" }}>
                <Button onClick={resetCommssionGrp} className="w-100 bg-warning border-0 rounded-0 btn-height text-dark btn-com-grp">
                  Reset
                </Button>
              </Col>
            </Row>

            {/* staper */}
            <Nav
              variant="pills"
              className="justify-content-between align-items-center mt-4 crte-cm-grp-step"
            >
              <Nav.Item>
                <Nav.Link
                  active={activeStep === 1}
                  className={`d-flex flex-col step-link${activeStep === 1 ? "  d-flex flex-col active-step " : ""
                    }`}
                >
                  <span className="step-number">1</span>
                  <div className="step-content">
                    <small className="step-text">Fill general fields</small>
                    <small className="step-text">Required</small>
                  </div>
                </Nav.Link>
              </Nav.Item>
              <IoIosArrowForward />
              <Nav.Item>
                <Nav.Link
                  active={activeStep === 2}
                  disabled={activeStep < 2}
                  className={`d-flex flex-col step-link ${activeStep === 2 ? " d-flex flex-col active-step" : ""
                    }`}
                >
                  <span className="step-number">2</span>
                  <div className="step-content">
                    <small className="step-text">Revenue Share</small>
                    <small className="step-text">Not required</small>
                  </div>
                </Nav.Link>
              </Nav.Item>
              <IoIosArrowForward />
              <Nav.Item>
                <Nav.Link
                  active={activeStep === 3}
                  disabled={activeStep < 3}
                  className={`d-flex flex-col step-link ${activeStep === 3 ? "d-flex flex-col active-step" : ""
                    }`}
                >
                  <span className="step-number">3</span>
                  <div className="step-content">
                    <small className="step-text">CPA</small>
                    <small className="step-text">Not required</small>
                  </div>
                </Nav.Link>
              </Nav.Item>
              <IoIosArrowForward />
              <Nav.Item>
                <Nav.Link
                  active={activeStep === 4}
                  disabled={activeStep < 4}
                  className={`d-flex flex-col step-link ${activeStep === 4 ? "d-flex flex-col active-step" : ""
                    }`}
                >
                  <span className="step-number">4</span>
                  <div className="step-content">
                    <small className="step-text">Referral</small>
                    <small className="step-text">Not required</small>
                  </div>
                </Nav.Link>
              </Nav.Item>
              <IoIosArrowForward />
              <Nav.Item>
                <Nav.Link
                  active={activeStep === 5}
                  disabled={activeStep < 5}
                  className={`d-flex flex-col step-link ${activeStep === 5 ? "d-flex flex-col active-step" : ""
                    }`}
                >
                  <span className="step-number">5</span>
                  <div className="step-content">
                    <small className="step-text">Final fields</small>
                    <small className="step-text">Required</small>
                  </div>
                </Nav.Link>
              </Nav.Item>
            </Nav>

            {/* Progress Bar */}
            <ProgressBar
              now={(activeStep / totalSteps) * 100}
              className="mb-4 progress-bar-custom"
              style={{ height: "3px" }}
            />

            {/* Conditional Rendering of Form Sections */}
            <Form>
              {activeStep === 1 && (
                <>
                  <h3 style={{ fontSize: 17 }} className="text-start">Fill general fields</h3>
                  <Row className="justify-content-between  mt-4 me-auto w-100">
                    <Col lg={6} md={4} sm={4}>
                      <div className="form-cre-grp-fl-wp">
                        <div className="form-cre-grp-fl-wp-lb">
                          <label> Group name </label>
                        </div>
                        <div className="form-cre-grp-fl-wp-in">
                          <Form.Control type="text" disabled={!affliatePermission} value={CommissionGrp.name} onChange={e => setCommissionGrp({ ...CommissionGrp, name: e.target.value })} style={{ borderRadius: 3, borderColor: "rgba(0,0,0,0.2)" }} />
                          {GrprsValidation.name != null ? (<> <div style={{ textTransform: "capitalize" }} class="invalid-feedback loginForm">{GrprsValidation.name}</div></>) : (<></>)}
                        </div>
                      </div>
                    </Col>

                  </Row>

                  <Row className="justify-content-between mt-4 me-auto w-100">
                    <Col lg={6} md={4} sm={4}>
                      <div className="form-cre-grp-fl-wp">
                        <div className="form-cre-grp-fl-wp-lb">
                          <label> Currency </label>
                        </div>
                        <div className="form-cre-grp-fl-wp-in">
                          <Select isDisabled={!affliatePermission} options={optionsCurrency} value={selectedCurrencyValue} />
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row className="justify-content-between mt-4 me-auto w-100">
                    <Col lg={6} md={4} sm={4}>
                      <div className="form-cre-grp-fl-wp">
                        <div className="form-cre-grp-fl-wp-lb">
                          <label> Structure type for next step  </label>
                        </div>
                        <div className="form-cre-grp-fl-wp-in">
                          <Select isDisabled={!affliatePermission} options={optionsStructureType} onChange={e => setStructureType({ ...structureType, type: e.value })} />
                          <div>
                            {GrprsValidation.type != null ? (<> <div style={{ textTransform: "capitalize" }} class="invalid-feedback loginForm">{GrprsValidation.type}</div></>) : (<></>)}
                          </div>
                        </div>
                      </div>
                    </Col>

                  </Row>

                  <Row className="justify-content-between mt-4 me-auto w-100">
                    <Col lg={6} md={4} sm={4}>
                      <div className="form-cre-grp-fl-wp">
                        <div className="form-cre-grp-fl-wp-lb" style={{ maxWidth: 40 }}>
                          <ChartCheckbox size="12px" color="#1a1650" label="" reset={resetTrigger} />
                        </div>
                        <div>
                          <label
                            htmlFor="custom-checkbox"
                            className="text-gray-700 cursor-pointer"
                          >
                            Perpetual group
                          </label>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </>
              )}
              {activeStep === 2 && (
                <>

                  <h3 style={{ fontSize: 17 }} className="text-start">Revenue Share</h3>
                  <>
                    <Row className="justify-content-between align-items-center mt-4 me-auto w-150">
                      <Col lg={3} md={4} sm={4}>
                        <div className="form-cre-grp-fl-wp-gd">
                          <div className="form-cre-grp-fl-wp-lb">
                            <label> Commission calculation basis </label>
                          </div>
                          <div className="form-cre-grp-fl-wp-in">
                            <div style={{ display: "grid" }}>
                              <Select options={optionsCalculBasis} value={CommissionGrp.rs_structure.calcbasis != null ? optionsCalculBasis.find(d => d.value == CommissionGrp.rs_structure.calcbasis) : ""} onChange={e => { setCommissionGrp(prevstat => ({ ...prevstat, rs_structure: { ...prevstat.rs_structure, calcbasis: e.value } })) }} />
                              {GrprsValidation.st_rs.calcbasis != null ? (<> <div style={{ textTransform: "capitalize" }} class="invalid-feedback loginForm">{GrprsValidation.st_rs.calcbasis}</div></>) : (<></>)}
                            </div>
                          </div>
                        </div>
                      </Col>

                      <Col lg={3} md={4} sm={4}>
                        <div className="form-cre-grp-fl-wp-gd">
                          <div className="form-cre-grp-fl-wp-lb">
                            <label> Commission % </label>
                          </div>
                          <div className="form-cre-grp-fl-wp-in">
                            <div style={{ display: "grid" }}>
                              <Form.Control style={{ borderRadius: 3, borderColor: "rgba(0,0,0,0.2)" }} type="text" value={CommissionGrp.rs_structure.percentage} onChange={e => { setCommissionGrp(prevstat => ({ ...prevstat, rs_structure: { ...prevstat.rs_structure, percentage: e.target.value } })) }} />
                              {GrprsValidation.st_rs.commi != null ? (<> <div style={{ textTransform: "capitalize" }} class="invalid-feedback loginForm">{GrprsValidation.st_rs.commi}</div></>) : (<></>)}
                            </div>
                          </div>
                        </div>
                      </Col>
                      <Col lg={3} md={4} sm={4}>
                        <div className="form-cre-grp-fl-wp-gd">
                          <div className="form-cre-grp-fl-wp-lb">
                            <label>Include Negative Commission </label>
                          </div>
                          <div className="form-cre-grp-fl-wp-in">
                            <Select options={optionsNegativeCom} value={selectedNgatveCom} onChange={e => { setCommissionGrp(prevstat => ({ ...prevstat, rs_structure: { ...prevstat.rs_structure, negativecomm: e.value } })) }} />
                          </div>
                        </div>
                      </Col>
                      <Col lg={3} md={4} sm={5}>
                        <div className="form-cre-grp-fl-wp-gd">
                          <div className="form-cre-grp-fl-wp-lb">
                            <label> Administrator </label>
                          </div>
                          <div className="form-cre-grp-fl-wp-in">
                            <div style={{ display: "grid" }}>
                              <Form.Control style={{ borderRadius: 3, borderColor: "rgba(0,0,0,0.2)" }} type="text" value={CommissionGrp.rs_structure.administrator} onChange={e => { setCommissionGrp(prevstat => ({ ...prevstat, rs_structure: { ...prevstat.rs_structure, administrator: e.target.value } })) }} />
                              {GrprsValidation.st_rs.administrator != null ? (<> <div style={{ textTransform: "capitalize" }} class="invalid-feedback loginForm">{GrprsValidation.st_rs.administrator}</div></>) : (<></>)}
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>

                    <Row className="justify-content-between mt-4 me-auto w-100">
                      <Col lg={6} md={4} sm={4}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <div style={{ maxWidth: 40 }}>
                            <ChartCheckbox initialChecked={isChecked} size="12px" onChange={handleCheckboxChange} label="" />
                          </div>
                          <div style={{ marginLeft: 5 }}>
                            <label
                              htmlFor="custom-checkbox"
                              className="text-gray-700 cursor-pointer"
                            >
                              Create multi-tiered structure
                            </label>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    {
                      isChecked ? (
                        <>
                          <div className="structure-wrap"  >
                            <h5 className="text-start  mt-4" style={{ fontSize: "15px", fontWeight: 'normal', color: "gray" }}>Parameters for tier</h5>


                            <Row className="justify-content-between mt-2 me-auto w-100">
                              <Col lg={12} md={4} sm={4}>
                                <div className="d-flex flex-col gap-3" style={{ overflowX: "auto" }}>
                                  <div style={{ display: "flex", alignItems: "center", minWidth: 200 }}>
                                    <div style={{ maxWidth: 40 }}>
                                      <ChartCheckbox initialChecked={registartionsChecked} size="12px" onChange={handleRegistrationchange} label="" />
                                    </div>
                                    <div style={{ marginLeft: 5 }}>
                                      <label
                                        htmlFor="custom-checkbox"
                                        className="text-gray-700 cursor-pointer"
                                      >
                                        Registrations with deposit
                                      </label>
                                    </div>
                                  </div>

                                  <div style={{ display: "flex", alignItems: "center", minWidth: 200 }}>
                                    <div style={{ maxWidth: 40 }}>
                                      <ChartCheckbox initialChecked={depositChecked} size="12px" onChange={handleDepositChange} label="" />
                                    </div>
                                    <div style={{ marginLeft: 5 }}>
                                      <label
                                        htmlFor="custom-checkbox"
                                        className="text-gray-700 cursor-pointer"
                                      >
                                        New deposit amount
                                      </label>
                                    </div>
                                  </div>
                                  <div style={{ display: "flex", alignItems: "center", minWidth: 200 }}>
                                    <div style={{ maxWidth: 40 }}>
                                      <ChartCheckbox initialChecked={profitChecked} size="12px" onChange={handleProfitChange} label="" />
                                    </div>
                                    <div style={{ marginLeft: 5 }}>
                                      <label
                                        htmlFor="custom-checkbox"
                                        className="text-gray-700 cursor-pointer"
                                      >
                                        Profit
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                {rsValidation != "" ? (<div style={{ textTransform: "lowercase" }} class="invalid-feedback loginForm"> {rsValidation}</div>) : (<></>)}
                              </Col>
                            </Row>



                            {levels.length === 0 ? null : (
                              levels.map((level, index) => (
                                <div key={index}>

                                  <h5 className="text-start mt-4" style={{ color: "gray" }}>Level {index + 1}</h5>
                                  <Row className="mt-2 me-4 w-75  grp-comm-with ">
                                    <Col style={{ width: "100%" }} lg={4} md={4} sm={5} className=" pt-2">
                                      <div className="grp-cm-wp">
                                        <div style={{ marginLeft: 5 }} className="form-cre-grp-fl-wp-gd">
                                          <div className="form-cre-grp-fl-wp-lb">
                                            <label> Commission % </label>
                                          </div>
                                          <div className="form-cre-grp-fl-wp-in">
                                            <Form.Control style={{ borderRadius: 3, borderColor: "rgba(0,0,0,0.2)" }} type="text" placeholder="0" value={level.percentage} onChange={(event) => {
                                              const { value } = event.target;
                                              const newValue = isNaN(value) ? level.percentage : Number(value);
                                              setLevels(prevLevels => {
                                                return prevLevels.map((lvl, i) =>
                                                  i === index ? { ...lvl, percentage: newValue } : lvl
                                                )
                                              }
                                              );
                                            }} />
                                          </div>
                                          <div>
                                            {tiersValidations.length > 0 && tiersValidations[index].index === index && tiersValidations[index].percentage ? (
                                              <>
                                                <div style={{ textTransform: "capitalize" }} class="invalid-feedback loginForm">{tiersValidations[index].percentage}</div>
                                              </>
                                            ) : (<></>)}
                                          </div>
                                        </div>
                                        {registartionsChecked ? (
                                          <div style={{ marginLeft: 5 }} className="form-cre-grp-fl-wp-gd">
                                            <div className="form-cre-grp-fl-wp-lb">
                                              <label> Registrations with deposits </label>
                                            </div>
                                            <div className="form-cre-grp-fl-wp-in">
                                              <Form.Control style={{ borderRadius: 3, borderColor: "rgba(0,0,0,0.2)" }} type="text" placeholder="0" value={level.registrations} onChange={(event) => {

                                                const { value } = event.target;
                                                const newValue = isNaN(value) ? level.registrations : Number(value);
                                                setLevels(prevLevels => {
                                                  return prevLevels.map((lvl, i) =>
                                                    i === index ? { ...lvl, registrations: registartionsChecked ? newValue : 0 } : lvl
                                                  )
                                                }
                                                );
                                              }} />
                                            </div>
                                            <div>
                                              {tiersValidations.length > 0 && tiersValidations[index].index === index && tiersValidations[index].registrations ? (
                                                <>
                                                  <div style={{ textTransform: "capitalize" }} class="invalid-feedback loginForm">{tiersValidations[index].registrations}</div>
                                                </>
                                              ) : (<></>)}
                                            </div>
                                          </div>) : (<></>)}
                                        {depositChecked ? (
                                          <div style={{ marginLeft: 5 }} className="form-cre-grp-fl-wp-gd">
                                            <div className="form-cre-grp-fl-wp-lb">
                                              <label> New deposit Amount </label>
                                            </div>
                                            <div className="form-cre-grp-fl-wp-in">
                                              <Form.Control style={{ borderRadius: 3, borderColor: "rgba(0,0,0,0.2)" }} type="text" placeholder="0.00" value={level.deposits} onChange={(event) => {
                                                const { value } = event.target;
                                                const newValue = isNaN(value) ? level.deposits : Number(value);
                                                setLevels(prevLevels => {
                                                  return prevLevels.map((lvl, i) =>
                                                    i === index ? { ...lvl, deposits: newValue } : lvl
                                                  )
                                                }
                                                );
                                              }} />
                                            </div>
                                            <div>
                                              {tiersValidations.length > 0 && tiersValidations[index].index === index && tiersValidations[index].deposits ? (
                                                <>
                                                  <div style={{ textTransform: "capitalize" }} class="invalid-feedback loginForm">{tiersValidations[index].deposits}</div>
                                                </>
                                              ) : (<></>)}
                                            </div>
                                          </div>

                                        ) : (<></>)}
                                        {profitChecked ? (
                                          <div style={{ marginLeft: 5 }} className="form-cre-grp-fl-wp-gd">
                                            <div className="form-cre-grp-fl-wp-lb">
                                              <label> Profit </label>
                                            </div>
                                            <div className="form-cre-grp-fl-wp-in">
                                              <Form.Control style={{ borderRadius: 3, borderColor: "rgba(0,0,0,0.2)" }} type="text" placeholder="0" value={level.profit} onChange={(event) => {
                                                const { value } = event.target;
                                                const newValue = isNaN(value) ? level.profit : Number(value);
                                                setLevels(prevLevels => {
                                                  return prevLevels.map((lvl, i) =>
                                                    i === index ? { ...lvl, profit: newValue } : lvl
                                                  )
                                                }
                                                );
                                              }} />
                                            </div>
                                            <div>
                                              {tiersValidations.length > 0 && tiersValidations[index].index === index && tiersValidations[index].profit ? (
                                                <>
                                                  <div style={{ textTransform: "capitalize" }} class="invalid-feedback loginForm">{tiersValidations[index].profit}</div>
                                                </>
                                              ) : (<></>)}
                                            </div>
                                          </div>
                                        ) : (<></>)}
                                      </div>
                                    </Col>
                                  </Row>


                                </div>
                              ))
                            )}
                            <Row className="mt-2 me-4 w-75  ">
                              <Col lg={10} md={4} sm={5} className=" pt-2">
                                <div className="form-cre-grp-fl-wp">
                                  <div style={{ maxWidth: 250 }} className="form-cre-grp-fl-wp-lb">
                                    <label> Commission % higher then level [<span style={{ fontWeight: 600 }}>{levels.length}</span>]  </label>
                                  </div>
                                  <div style={{ maxWidth: 155, display: "grid" }} className="form-cre-grp-fl-wp-in">
                                    <div>
                                      <Form.Control style={{ borderRadius: 3, borderColor: "rgba(0,0,0,0.2)" }} type="text" value={lastTtier.percentage} onChange={e => { setLastTier({ ...lastTtier, percentage: e.target.value }) }} />
                                    </div>

                                  </div>

                                </div>
                                {GrprsValidation.st_rs.last_tier != null ? (<> <div style={{ textTransform: "capitalize" }} class="invalid-feedback loginForm">{GrprsValidation.st_rs.last_tier}</div></>) : (<></>)}

                              </Col>
                            </Row>

                            <Row className="mt-4 me-4 w-75 mb-5">
                              <Col lg={4} md={4} sm={5} className=" pt-2" >
                                <Button
                                  className="w-100 bg-warning border-0 rounded-0 btn-height text-dark btn-com-grp "
                                  onClick={handleAddLevel}
                                >
                                  Add level
                                </Button>
                              </Col>
                              {levels.length > 1 && (
                                <Col lg={4} md={4} sm={5} className=" pt-2">
                                  <Button
                                    className="w-100 bg-warning border-0 rounded-0 btn-height text-dark btn-com-grp"
                                    onClick={handleDeleteLevel}
                                  >
                                    Delete level
                                  </Button>
                                </Col>
                              )}
                            </Row>

                          </div>
                        </>
                      ) : null
                    }
                  </>



                  {!usedRs ? (
                    <Row className="mt-4 me-4 w-75 mb-5">
                      <Col lg={4} md={4} sm={5} className=" pt-2">
                        <Button onClick={createRevenueShareStruct} className="w-100 bg-warning border-0 rounded-0 btn-height text-dark btn-com-grp">
                          Create structure
                        </Button>
                      </Col>
                    </Row>
                  ) : (
                    <>
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "#fff", padding: 10 }}>

                        <div >
                          <label>Data  saved </label>
                        </div>
                        <div style={{ marginLeft: 12 }}>
                          <img src={require("../../../../assets/checked.png")} width="22" />
                        </div>
                      </div>
                    </>)}
                </>
              )}
              {activeStep === 3 && (
                <>
                  <h3 style={{ fontSize: 17 }} className="text-start">CPA</h3>
                  {/* Content for Step 3 */}
                  <>
                    <Row className="justify-content-start mt-4 me-auto w-75">
                      <Col lg={4} md={4} sm={4}>
                        <div className="form-cre-grp-fl-wp-gd">
                          <div className="form-cre-grp-fl-wp-lb">
                            <label>CPA amount </label>
                          </div>
                          <div className="form-cre-grp-fl-wp-in">
                            <Form.Control style={{ borderRadius: 3, borderColor: "rgba(0,0,0,0.2)" }} type="text" placeholder="0" value={CommissionGrp.cpa_structure.amount} onChange={e => { setCommissionGrp(prevstat => ({ ...prevstat, cpa_structure: { ...prevstat.cpa_structure, amount: e.target.value } })) }} />
                          </div>
                          {GrprsValidation.st_cpa && GrprsValidation.st_cpa.cpa != null ? (<> <div style={{ textTransform: "capitalize" }} class="invalid-feedback loginForm">{GrprsValidation.st_cpa.cpa}</div></>) : (<></>)}
                        </div>
                      </Col>
                      <Col lg={4} md={4} sm={5}>
                        {/* <div className="form-cre-grp-fl-wp-gd">
                      <div className="form-cre-grp-fl-wp-lb">
                        <label> Days off Hold </label>
                      </div>
                      <div className="form-cre-grp-fl-wp-in">
                        <input type="text" />
                      </div>
                    </div> */}
                      </Col>
                    </Row>
                    <div >
                      <div >

                        {cpaParamLevel.length === 0 ? (<></>) : (
                          cpaParamLevel.map((level, index) => (
                            <div key={index} style={{ display: "flex", alignItems: "center" }}>
                              <div style={{ flex: 1, maxWidth: 224 }}>
                                <div style={{ maxWidth: 250, paddingTop: 10 }} lg={4} md={4} sm={4}>
                                  <div className="form-cre-grp-fl-wp-gd">
                                    <div className="form-cre-grp-fl-wp-lb">
                                      <label> Minimum/month </label>
                                    </div>
                                    <div className="form-cre-grp-fl-wp-in">
                                      <Form.Control style={{ borderRadius: 3, borderColor: "rgba(0,0,0,0.2)" }} type="text" placeholder="0" />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {cpaParamLevel.length > 0 ? (
                                <div style={{ flex: 1, maxWidth: 250, paddingTop: 10 }}>
                                  <div style={{ maxWidth: 200, marginLeft: 10 }} lg={4} md={4} sm={5}>
                                    <div className="form-cre-grp-fl-wp-gd">
                                      <div className="form-cre-grp-fl-wp-lb">
                                        <label> Main parameter </label>
                                      </div>
                                      <div className="form-cre-grp-fl-wp-in">
                                        <Form.Control style={{ borderRadius: 3, borderColor: "rgba(0,0,0,0.2)" }} type="text" />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ) : (<></>)}
                            </div>
                          )))}
                      </div>
                    </div>
                    <Row className="mt-4 me-4 w-75 ">
                      <Col lg={4} md={4} sm={5} className=" pt-2">
                        {/* <Button className="w-100 bg-warning border-0 rounded-0 btn-height text-dark btn-com-grp" onClick={addCpaParamLevel}>
                      Add parameter
                    </Button> */}
                      </Col>
                      {cpaParamLevel.length > 0 ? (
                        <Col lg={4} md={4} sm={5} className=" pt-2">
                          <Button className="w-100 bg-warning border-0 rounded-0 btn-height text-dark btn-com-grp" onClick={deleteCpaParamLevel}>
                            Remove parameter
                          </Button>
                        </Col>
                      ) : (<></>)}
                    </Row>



                    <Row className="justify-content-between mt-4 me-auto w-100">

                    </Row>
                    <div>
                      {strcutre ? (
                        <>
                          <div className="stucture-wrap">

                            {cpaLevel.length === 0 ? null : (
                              cpaLevel.map((level, index) => (
                                <div key={index}>

                                  <h5 className="text-start mt-4" style={{ color: "gray" }}>Level {index + 1}</h5>
                                  <Row className="mt-2 me-4 w-75  grp-comm-with d">
                                    <div style={{ display: "flex" }}>
                                      <Col style={{ width: "100%", maxWidth: 230 }} lg={4} md={4} sm={5} className=" pt-2">
                                        <div className="grp-cm-wp">
                                          <div className="form-cre-grp-fl-wp-gd">
                                            <div className="form-cre-grp-fl-wp-lb">
                                              <label> Payment per player </label>
                                            </div>
                                            <div className="form-cre-grp-fl-wp-in">
                                              <Form.Control style={{ borderRadius: 3, borderColor: "rgba(0,0,0,0.2)" }} type="text" placeholder="0" />
                                            </div>
                                          </div>
                                        </div>
                                      </Col>
                                      <Col style={{ width: "100%", maxWidth: 230 }} lg={4} md={4} sm={5} className=" pt-2">
                                        <div className="grp-cm-wp">
                                          <div className="form-cre-grp-fl-wp-gd">
                                            <div className="form-cre-grp-fl-wp-lb">
                                              <label> Number of players up to.... </label>
                                            </div>
                                            <div className="form-cre-grp-fl-wp-in">
                                              <Form.Control style={{ borderRadius: 3, borderColor: "rgba(0,0,0,0.2)" }} type="text" placeholder="0" />
                                            </div>
                                          </div>
                                        </div>
                                      </Col>
                                    </div>
                                  </Row>


                                </div>
                              ))
                            )}
                          </div>
                          <div>
                            <Row className="mt-4 me-4 w-75 ">
                              <Col lg={4} md={4} sm={5} className=" pt-2">
                                <Button className="w-100 bg-warning border-0 rounded-0 btn-height text-dark btn-com-grp" onClick={addCpaLevel}>
                                  Add level
                                </Button>
                              </Col>
                              {cpaLevel.length > 1 ? (
                                <Col lg={4} md={4} sm={5} className=" pt-2">
                                  <Button className="w-100 bg-warning border-0 rounded-0 btn-height text-dark btn-com-grp" onClick={handleDeleteCpaLevel}>
                                    Remove level
                                  </Button>
                                </Col>
                              ) : (<></>)}
                            </Row>
                          </div>
                          <Row className="mt-2 me-4 w-75  ">
                            <Col lg={10} md={4} sm={5} className=" pt-2">
                              <div className="form-cre-grp-fl-wp">
                                <div style={{ maxWidth: 280 }} className="form-cre-grp-fl-wp-lb">
                                  <label> Payment per player higher than level [<span style={{ fontWeight: 600 }}>{cpaLevel.length}</span>]  </label>
                                </div>
                                <div style={{ maxWidth: 150 }} className="form-cre-grp-fl-wp-in">
                                  <Form.Control style={{ borderRadius: 3, borderColor: "rgba(0,0,0,0.2)" }} type="text" placeholder="0.00" />
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </>
                      ) : (<></>)}
                    </div>
                    {!usedcpa ? (
                      <Row className="mt-4 me-4 w-75 mb-4 ">
                        <Col lg={4} md={4} sm={5} className=" pt-2">
                          <Button onClick={createCPAStruct} className="w-100 bg-warning border-0 rounded-0 btn-height text-dark btn-com-grp">
                            Create structure
                          </Button>
                        </Col>
                      </Row>
                    ) : (
                      <>
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "#fff", padding: 10 }}>

                          <div >
                            <label>Data  saved </label>
                          </div>
                          <div style={{ marginLeft: 12 }}>
                            <img src={require("../../../../assets/checked.png")} width="22" />
                          </div>
                        </div>
                      </>)}
                  </>

                </>
              )}
              {activeStep === 4 && (
                <>
                  <h3 style={{ fontSize: 17 }} className="text-start">Referral</h3>
                  <>
                    <Row className="justify-content-start mt-4 me-auto w-100">
                      <Col lg={4} md={4} sm={4}>
                        <div className="form-cre-grp-fl-wp-gd">
                          <div className="form-cre-grp-fl-wp-lb">
                            <label>Include Negative Commission </label>
                          </div>
                          <div className="form-cre-grp-fl-wp-in">

                            <Select value={optionsNegativeCom.find(d => d.value == CommissionGrp.ref_structure.negativecomm)} options={optionsNegativeCom} onChange={e => { setCommissionGrp(prevstat => ({ ...prevstat, ref_structure: { ...prevstat.ref_structure, negativecomm: e.value } })) }} />

                          </div>
                        </div>
                      </Col>
                      <Col lg={4} md={4} sm={5}>
                        <div className="form-cre-grp-fl-wp-gd">
                          <div className="form-cre-grp-fl-wp-lb">
                            <label>Commission calculation basis </label>
                          </div>
                          <div className="form-cre-grp-fl-wp-in">
                            <Select value={optionsCalculBasisRef.find(d => d.value == CommissionGrp.ref_structure.calcbasis)} options={optionsCalculBasisRef} onChange={e => { setCommissionGrp(prevstat => ({ ...prevstat, ref_structure: { ...prevstat.ref_structure, calcbasis: e.value } })) }} />
                          </div>
                        </div>
                      </Col>
                    </Row>

                    {commmissionLevel.length === 0 ? null : (
                      commmissionLevel.map((level, index) => (
                        <div key={index}>

                          <h5 className="text-start mt-4" style={{ color: "gray" }}>Level {index + 1}</h5>
                          <Row className="mt-2 me-4 w-75  grp-comm-with d">
                            <div style={{ display: "flex" }}>
                              <Col style={{ width: "100%", maxWidth: 230 }} lg={4} md={4} sm={5} className=" pt-2">
                                <div className="grp-cm-wp">
                                  <div className="form-cre-grp-fl-wp-gd">
                                    <div className="form-cre-grp-fl-wp-lb">
                                      <label> Commission % </label>
                                    </div>
                                    <div className="form-cre-grp-fl-wp-in">
                                      <Form.Control style={{ borderRadius: 3, borderColor: "rgba(0,0,0,0.2)" }} type="text" placeholder="0" onChange={(event) => {
                                        const { value } = event.target;
                                        const newValue = isNaN(value) ? level.percentage : Number(value);
                                        setCommissionLevel(prevLevels => {
                                          return prevLevels.map((lvl, i) =>
                                            i === index ? { ...lvl, percentage: newValue } : lvl
                                          )
                                        }
                                        );
                                      }} />
                                    </div>
                                    {GrprsValidation.st_ref.lvl && GrprsValidation.st_ref.lvl.length > 0 && GrprsValidation.st_ref.lvl[index].index === index && GrprsValidation.st_ref.lvl[index].percentage ? (
                                      <>
                                        <div style={{ textTransform: "capitalize" }} class="invalid-feedback loginForm">{GrprsValidation.st_ref.lvl[index].percentage}</div>
                                      </>
                                    ) : (<></>)}
                                  </div>
                                </div>
                              </Col>
                            </div>
                          </Row>

                        </div>
                      ))
                    )}
                    <Row className="mt-4 me-4 w-75 ">
                      <Col lg={4} md={4} sm={5} className=" pt-2">
                        <Button className="w-100 bg-warning border-0 rounded-0 btn-height text-dark btn-com-grp" onClick={addCommissionLevel}>
                          Add level
                        </Button>
                      </Col>
                      {commmissionLevel.length > 1 ? (
                        <Col lg={4} md={4} sm={5} className=" pt-2">
                          <Button className="w-100 bg-warning border-0 rounded-0 btn-height text-dark btn-com-grp" onClick={handleDeleteCommissionLevel}>
                            Remove level
                          </Button>
                        </Col>
                      ) : (<></>)}
                    </Row>
                    {!usedRef ? (
                      <Row className="mt-2 me-4 w-75 ">
                        <Col lg={4} md={4} sm={5} className=" pt-2">
                          <Button onClick={createRefStruct} className="w-100 bg-warning border-0 rounded-0 btn-height text-dark btn-com-grp">
                            Create structure
                          </Button>
                        </Col>
                      </Row>
                    ) : (
                      <>
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "#fff", padding: 10 }}>

                          <div >
                            <label>Data  saved </label>
                          </div>
                          <div style={{ marginLeft: 12 }}>
                            <img src={require("../../../../assets/checked.png")} width="22" />
                          </div>
                        </div>
                      </>)}
                  </>



                </>
              )}
              {activeStep === 5 && (
                <>
                  <h3 style={{ fontSize: 17 }} className="text-start">Final fields</h3>
                  <h5
                    className="text-start"
                    style={{ fontSize: "13px", color: "gray" }}
                  >
                    Description preview :
                  </h5>
                  <h5 style={{ fontSize: 15 }} className="text-start">Revenue share</h5>
                  <h5
                    className="text-start"
                    style={{ fontSize: "13px", color: "gray" }}
                  >
                    {CommissionGrp.rs_structure.used ? (
                      <>
                        <div className="review-create-comm">
                          Negative Commission: {CommissionGrp.rs_structure.negativecomm ? (<>yes</>) : (<>no</>)}; Administrator:{CommissionGrp.rs_structure.administrator}%; MLM Calculation Type:{CommissionGrp.rs_structure.calcbasis};
                          {CommissionGrp.rs_structure.tiers ? (
                            <>
                              Levels: {levels.map((lvl, index) => (
                                <React.Fragment key={index}>
                                  <span style={{ paddingLeft: 3, paddingRight: 3 }}>|</span>{index + 1}/{tierConditions.profit ? <>{lvl.profit}/</> : <></>}{tierConditions.registrations ? <>{lvl.registrations}/</> : <></>}{tierConditions.deposits ? <>{lvl.deposits}/</> : <></>}{lvl.percentage} %
                                </React.Fragment>
                              ))}
                            </>) : (<></>)}
                        </div>
                        <div className="review-create-comm">

                          {CommissionGrp.rs_structure.tiers ? (
                            <>
                              Level number/{tierConditions.profit ? <>Profit/</> : <></>}{tierConditions.registrations ? <>Registrations with deposit/</> : <></>}{tierConditions.deposits ? <>new deposit amount/</> : <></>}
                            </>
                          ) : (<></>)}
                          Commission %; {CommissionGrp.rs_structure.tiers ? (<> Commission % if stated levels are exceeded:  {lastTtier.percentage}%;</>) : (<>{CommissionGrp.rs_structure.percentage}%</>)}
                        </div>
                      </>
                    ) : (<>- -</>)}
                  </h5>
                  <h5 style={{ fontSize: 15 }} className="text-start">CPA</h5>
                  <h5
                    className="text-start"
                    style={{ fontSize: "13px", color: "gray" }}
                  >
                    {CommissionGrp.cpa_structure.used ? (<>
                      <div className="review-create-comm">
                        CPA Amount: {parseFloat(CommissionGrp.cpa_structure.amount).toFixed(2)} USD
                      </div>
                    </>)
                      : (<>- -</>)}
                  </h5>
                  <h5 style={{ fontSize: 15 }} className="text-start">Referral</h5>
                  <h5
                    className="text-start"
                    style={{ fontSize: "13px", color: "gray" }}
                  >
                    {CommissionGrp.ref_structure.used ? (
                      <>
                        <div className="review-create-comm">

                          {commmissionLevel.map((lvl, index) => (
                            <React.Fragment key={index}>
                              Level {index + 1}| {lvl.percentage}<span style={{ paddingRight: 3, paddingLeft: 1 }}>%</span>
                            </React.Fragment>
                          ))} ; Negative Commission: {CommissionGrp.ref_structure.negativecomm ? (<>yes</>) : (<>no</>)}
                        </div>
                      </>) :
                      (<>
                        - -
                      </>)}
                  </h5>
                  {/* Content for Step 5 */}
                </>
              )}

              {/* Navigation Buttons */}
              <Row className="mt-4 d-flex align-items-center justify-content-start">
                <Col className="d-flex align-items-end">
                  <Button
                    variant="warning"
                    className="px-5 py-1 btn-com-grp-back"
                    onClick={handleBack}
                    disabled={activeStep === 1}
                    style={{
                      height: "30px",
                      borderRadius: "0px",
                      textAlign: "center",
                    }} // Ensure height consistency
                  >
                    Back
                  </Button>

                  <Button
                    variant="warning"
                    className="px-4 btn-com-grp-next"
                    onClick={handleNext}
                    style={{
                      height: "40px",
                      borderRadius: "0px",
                      textAlign: "center",
                    }} // Make this button taller
                    loading={pLoading}
                    disabled={!affliatePermission || pLoading}
                  >
                    {activeStep < totalSteps
                      ? `Next (Step ${activeStep} of ${totalSteps})`
                      : <>{pLoading ? <Spinner size="sm"></Spinner> : "Finish"}</>}
                  </Button>
                </Col>
                <Col className="text-end"></Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default CreateGroup;
